export enum ErrorCode {
  LoginInvalidCredentials = "loginInvalidCredentials",
  LoginInvalidCredentialsTotp = "loginInvalidCredentialsTotp",
  LoginInactiveUser = "LoginInactiveUser",
  PatientAccountInvalidCredentials = "patientAccountInvalidCredentials",
  PatientAccountInvalidCredentialsMfa = "patientAccountInvalidCredentialsMfa",
  PatientAccountEmailAlreadyInUse = "PatientAccountEmailAlreadyInUse",
  PatientAccountLoginAttemptsExceeded = "PatientAccountLoginAttemptsExceeded",
  PatientAccountPasswordResetExpired = "PatientAccountPasswordResetExpired",
  PatientAccountLoginExpired = "PatientAccountLoginExpired",
  PatientAccountSmsAttemptsExceeded = "PatientAccountSmsAttemptsExceeded",
  PatientAccountSmsIncorrectCode = "PatientAccountSmsIncorrectCode",
  PatientAccountDuplicateEmail = "PatientAccountDuplicateEmail",
  RegistrationClosed = "registrationClosed",
  RegistrationAlreadyCreated = "registrationAlreadyCreated",
  RegistrationRequestExistingPatient = "registrationRequestExistingPatient",
  RegistrationRequestAcceptedHisKnown = "registrationRequestAcceptedHisKnown",
  RegistrationRequestCompletedHisUnknown = "registrationRequestCompletedHisUnknown",
  ReregistrationHisUnknown = "reregistrationHisUnknown",
  RegistrationHisFailed = "RegistrationHisFailed",
  WalkInConsultCreationClosed = "walkInConsultCreationClosed",
  WalkInConsultCreationQueueFull = "walkInConsultCreationQueueFull",
  IdentificationCheckError = "IdentificationCheckError",
  NoAgendaConfigured = "NoAgendaConfigured",
  HISLogout = "HISLogout",
  DuplicatePassword = "DuplicatePassword",
  PatientBSNAlreadyExists = "PatientBSNAlreadyExists",
  PatientBSNInvalid = "PatientBSNInvalid",
  CommunicationLogAccessDenied = "CommunicationLogAccessDenied",
  UsernameAlreadyInUse = "UsernameAlreadyInUse",

  MfaSessionNotFound = "mfaSessionNotFound",
  MfaInvalidToken = "mfaInvalidToken",
  MfaSessionExpired = "mfaSessionExpired",
  MfaMaxAttemptsReached = "mfaMaxAttemptsReached",
  MfaContextMismatch = "mfaContextMismatch",
  MfaCallNotAllowed = "mfaCallNotAllowed",
  MfaDeliveryCooldown = "mfaDeliveryCooldown",

  // Plato errors we can handle (see `PlatoErrorType`)
  NOT_CURRENT_QUESTION = "NOT_CURRENT_QUESTION",
}
